
import { ProductOrderReceiptDto, CreateProductOrderReceiptDto, StorageLocationDto, ProductCatalogDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { productOrderReceiptService, ProductOrderReceiptsFilters } from '@services/ProductOrderReceiptService'
import { combineReducers, createSlice, PayloadAction } from '@reduxjs/toolkit'

const { reducer: crudReducer, actions, thunks } = baseCrudReducer<
  ProductOrderReceiptDto,
  CreateProductOrderReceiptDto,
  {},
  ProductOrderReceiptsFilters
>('productOrderReceipt', productOrderReceiptService, { selectFilters: (state) => state.productOrderReceipt.crud.filters })

const selectedStorageLocationsSlice = createSlice({
  name: 'productOrderReceiptSelectedStorageLocations',
  initialState: {} as Record<string, StorageLocationDto>, // key: id
  reducers: {
    addSelectedStorageLocation: (
      state,
      action: PayloadAction<StorageLocationDto>
    ) => {
      state[action.payload.id] = action.payload
    },
    removeSelectedStorageLocation: (
      state,
      action: PayloadAction<string>
    ) => {
      delete state[action.payload]
    },
    resetSelectedStorageLocations: () =>
      ({} as Record<string, StorageLocationDto>),
  },
})

const selectedNewProductsSlice = createSlice({
  name: 'productOrderReceiptSelectedNewProducts',
  initialState: {} as Record<string, ProductCatalogDto>, // key: id
  reducers: {
    addSelectedNewProduct: (
      state,
      action: PayloadAction<ProductCatalogDto>
    ) => {
      state[action.payload.id] = action.payload
    },
    removeSelectedNewProduct: (
      state,
      action: PayloadAction<string>
    ) => {
      delete state[action.payload]
    },
    resetSelectedNewProducts: () =>
      ({} as Record<string, ProductCatalogDto>),
  },
})

export const {
  addSelectedStorageLocation,
  removeSelectedStorageLocation,
  resetSelectedStorageLocations,
} = selectedStorageLocationsSlice.actions
export const {
  addSelectedNewProduct,
  removeSelectedNewProduct,
  resetSelectedNewProducts,
} = selectedNewProductsSlice.actions

export default combineReducers({
  crud: crudReducer,
  selectedStorageLocations: selectedStorageLocationsSlice.reducer,
  selectedNewProducts: selectedNewProductsSlice.reducer,
})

export const { setFilters: setProductOrderReceiptFilters } = actions
export const {
  getAll: getProductOrderReceipts,
  create: createProductOrderReceipt,
} = thunks
